import React, { useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import HeartUnfill from './Heart-filled-remove.gif';
import Heartfill from './Heart-outline-add.gif';

const ModalWrapper = styled.section`
  font-family: 'Montserrat';
  width: 430px;
  height: 220px;
  padding: 30px;
  text-align: left;
  background: #f5f7f9;
  border-radius: 10px;
  box-shadow: 0px 8px 6px #00000029;
  color: #003876;
`;
const ModalTitle = styled.h1`
  margin-top: 0;
  color: inherit;
`;
const ModalBtnRow = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 40px;
`;

const ModalButton = styled.button`
  font-weight: 600;
  outline: none;
  background: #003876;
  border: none;
  z-index: 3;
  padding: 6px 18px;
  color: #fff;
  height: 37px;
  width: 145px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  letter-spacing: 0.1px;
  transition: all ease-in 300ms;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 50px;

  &:hover {
    background-color: #0b5ba3;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.6);
  }
`;

const ModalCancelButton = styled.button`
  font-weight: 600;
  outline: none;
  background: transparent;
  border: none;
  z-index: 3;
  letter-spacing: 0.1px;
  padding: 6px 18px;
  color: #fff;
  height: 37px;
  width: 145px;
  border-radius: 5px;
  border: 2px solid #003876;
  color: #003876;
  font-size: 16px;
  cursor: pointer;
  transition: all ease-in 300ms;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #0b5ba3;
    border-color: #0b5ba3;
    color: #fff;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.6);
  }
`;

const ConfirmModal = ({
  title = '',
  text = '',
  onClose = null,
  onClick = null,
  accept = true,
}) => {
  const heartIconRef = useRef(null);

  return (
    <div style={{ display: 'flex' }}>
      <ModalWrapper>
        <div style={{ width: '100%', height: '50px' }}>
          {accept ? (
            <img
              src={Heartfill}
              alt="heart"
              style={{
                height: '50px',
                width: '50px',
                margin: 'auto',
                display: 'block',
                paddingTop: '5px',
              }}
            />
          ) : (
            <img
              src={HeartUnfill}
              alt="heart"
              style={{
                height: '50px',
                width: '50px',
                margin: 'auto',
                display: 'block',
                paddingTop: '5px',
              }}
            />
          )}
        </div>
        <div
          style={{
            margin: 'auto',
            marginTop: 0,
            height: '90%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}>
          <ModalTitle>{title}</ModalTitle>
          <p style={{ fontSize: '13px', margin: 0, padding: 0 }}>{text}</p>
          <ModalBtnRow>
            <ModalCancelButton onClick={onClose}>Cancelar</ModalCancelButton>
            <ModalButton onClick={onClick}>
              {accept ? 'Agregar' : 'Eliminar'}
            </ModalButton>
          </ModalBtnRow>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default ConfirmModal;
